// extracted by mini-css-extract-plugin
export default {"container":"SubCategory_container__9llNI","title":"SubCategory_title__9pCpW"};